import * as React from 'react';
import { ITextProps, Text } from '@mc/react-core';
import classNames from 'classnames';
import { RF_ERROR, RF_HELPER_TEXT, RF_WARNING } from './classes';

export const HelperType = {
  WARNING: 'warning' as 'warning',
  ERROR: 'error' as 'error',
};
export type HelperType = typeof HelperType[keyof typeof HelperType];

export interface IHelperText extends ITextProps {
  type: HelperType;
}

export class HelperText extends React.PureComponent<IHelperText> {
  render() {
    const { className, type, children, ...other } = this.props;

    const cls = classNames(RF_HELPER_TEXT, className, {
      [RF_WARNING]: type === HelperType.WARNING,
      [RF_ERROR]: type === HelperType.ERROR,
    });

    return (
      <Text className={cls} {...other}>
        {children}
      </Text>
    );
  }
}
